import { useParams } from "react-router-dom";
import { useApp } from "@/hooks/use-app-context";
import { contributionKitCopy, kitLang, type ContributionKitCopy, type KitLang } from "./contribution-kit-copy";

/** Kit strings in the language of the route (`/:lang/...`), else the app's. */
export function useKitCopy(): { copy: ContributionKitCopy; lang: KitLang } {
  const { lang } = useParams<{ lang: string }>();
  const { language } = useApp();
  const resolved = kitLang(lang || language);
  return { copy: contributionKitCopy[resolved], lang: resolved };
}
